<template>
  <div>
      <div :class="view_class_view.div_container_section.container">
          
          <div :class="view_class_view.div_container_section.form">
              <div v-if="savingData.length>0">
                   <ChooseButton 
                   :buttons="savingData"
                   v-on:choose-button="changePaymentMethod($event)"
                   label="Método de pago:" 
                   :buttons_styles="buttons_styles"
                   />
                    <div class="content-text" style="float:left">
                      <template v-if="savingDataModelValidations.saving_registration_attributes.payment_method.$dirty">
                        <div class="input-errors" v-for="error of savingDataModelValidations.saving_registration_attributes.payment_method.$errors" :key="error.$uid">
                          <div :class="view_class_view.div_container_error.text_error" class="errors">{{ error.$message }}</div>
                        </div>
                      </template>
                    </div>
              </div>

              
              <div v-if="savingModelValidations.saving_registration_attributes.payment_method=='CargoTarjeta'">
                <div class="form-group">
                    <p class="label-input">Tipo de cuenta:</p>
                    <div class="input-group">
                      <input type="radio" name="rdbStatus" value="Cuenta Clabe" id="account_type_key_account"
                      v-on:change="changeAccountType($event.target.value)"/> <label for="account_type_key_account" class="ml-2" > Clabe interbancaria </label>
                      
                      <input type="radio" name="rdbStatus" value="Numero de tarjeta" id="account_type_card_number"
                      v-on:change="changeAccountType($event.target.value)" style="margin-left:20px;" inputmode="numeric"> <label for="account_type_card_number" class="ml-2"> Número de tarjeta</label>     
                    </div>
                  </div>
  
                <div class="content-text" style="float:left">
                  <template v-if="savingDataModelValidations.bank_account_attributes[0].account_type.$dirty">
                        <div class="input-errors" v-for="error of savingDataModelValidations.bank_account_attributes[0].account_type.$errors" :key="error.$uid">
                          <div :class="view_class_view.div_container_error.text_error" class="errors">{{ error.$message }}</div>
                      </div>
                    </template>
                </div>
  
              </div>
  
              <div v-if="savingModelValidations.saving_registration_attributes.payment_method=='CargoTarjeta'">
                <div class="form-group">
                    <label class="label-input">Banco:</label>
                      <div class="input-group" style="width:100%">
                        <select lang="en" translate="no" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor mt-2" ref="stateSelected"
                        :class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: savingDataModelValidations.bank_account_attributes[0].bank_name.$error,
                          [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!savingDataModelValidations.bank_account_attributes[0].bank_name.$invalid,
                          [view_class_view.classInputs.default ]: savingDataModelValidations.bank_account_attributes[0].bank_name.$invalid && !savingDataModelValidations.bank_account_attributes[0].bank_name.$error  }"
                         v-model.trim="savingDataModelValidations.bank_account_attributes[0].bank_name.$model">
                            <option value="" selected disabled >Seleccionar una opcion</option>
                            <option :value="item" v-for="(item,index) in list_banks" :key="item.id" :id="'option_bank_'+index" >{{item}}</option>
                        </select>
                    </div>
                </div>
                <div class="content-text" style="float:left;margin-top:10px"> 
                  <div class="input-errors" v-for="error of savingDataModelValidations.bank_account_attributes[0].bank_name.$errors" :key="error.$uid">
                    <div :class="view_class_view.div_container_error.text_error" class="errors">{{ error.$message }}</div>
                  </div>
                 </div>
              </div>
              <div v-if="savingModelValidations.bank_account_attributes[0].account_type=='Cuenta Clabe' && savingModelValidations.saving_registration_attributes.payment_method=='CargoTarjeta'">
                <p class="label-input">Clabe interbancaria:</p>
                <input type="text" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" id="input_card_number_saving_data"  v-maska="'##################'"  inputmode="numeric"
                style="color:#3B3B3B;" v-model.trim="savingDataModelValidations.bank_account_attributes[0].account_number.$model" @keyup="savingDataModelValidations.bank_account_attributes[0].account_number.$validate()"  v-on:change="changeAccountNumber($event.target.value);"
                @blur="savingDataModelValidations.bank_account_attributes[0].account_number.$validate()"
                :class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: savingDataModelValidations.bank_account_attributes[0].account_number.$error,
                  [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!savingDataModelValidations.bank_account_attributes[0].account_number.$invalid,
                  [view_class_view.classInputs.default ]: savingDataModelValidations.bank_account_attributes[0].account_number.$invalid && !savingDataModelValidations.bank_account_attributes[0].account_number.$error  }" >
  
               <div class="content-text" style="float:left;margin-top:10px">
                      <div v-if="savingDataModelValidations.bank_account_attributes[0].account_number.$dirty">
                        <div class="input-errors" v-for="error of savingDataModelValidations.bank_account_attributes[0].account_number.$errors" :key="error.$uid">
                          <span :class="view_class_view.div_container_error.text_error" class="errors">{{ error.$message }}</span>
                      </div>
                    </div>
                </div>
              </div>
              
              <div v-if="savingModelValidations.bank_account_attributes[0].account_type=='Numero de tarjeta' && savingModelValidations.saving_registration_attributes.payment_method=='CargoTarjeta'" >
                <p class="label-input">Número de tarjeta:</p>
                <input type="text" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor " id="input_card_number_saving_data" @keyup="savingDataModelValidations.bank_account_attributes[0].account_number.$validate()"
                @blur="savingDataModelValidations.bank_account_attributes[0].account_number.$validate()" v-on:change="changeAccountNumber($event.target.value);"
                 v-model.trim="savingDataModelValidations.bank_account_attributes[0].account_number.$model"  v-maska="bank_account_attributes[0].bank_name=='AMERICAN EXPRESS'?'####-######-#####':'####-####-####-####'" inputmode="numeric"   style="color:#3B3B3B;"
                 :class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: savingDataModelValidations.bank_account_attributes[0].account_number.$error,
                  [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!savingDataModelValidations.bank_account_attributes[0].account_number.$invalid,
                  [view_class_view.classInputs.default ]: savingDataModelValidations.bank_account_attributes[0].account_number.$invalid && !savingDataModelValidations.bank_account_attributes[0].account_number.$error  }" >

                <div class="content-text" style="float:left;margin-top:10px">
                  <div v-if="savingDataModelValidations.bank_account_attributes[0].account_number.$dirty">
                    <div class="input-errors" v-for="error of savingDataModelValidations.bank_account_attributes[0].account_number.$errors" :key="error.$uid">
                      <span :class="view_class_view.div_container_error.text_error" class="errors">{{ error.$message }}</span>
                  </div>
                </div>
               </div>
              </div>


              <div v-if="savingModelValidations.bank_account_attributes[0].account_type=='Numero de tarjeta' && savingModelValidations.saving_registration_attributes.payment_method=='CargoTarjeta'"  >
                    <p class="label-input">Fecha Vencimiento:</p>
                      <div class="shadow-md form-group rounded-lg">
                        <div style="display:flex;width: 100%;" >
                          <div style="width: 100%;">
                            <select class="rounded-lg w-full px-3 py-3 clear-focus border-2" style="border-right:none;border-top-right-radius:0;border-bottom-right-radius:0" 
                            id="input_expiration_date_saving_data_month" v-model.trim="savingDataModelValidations.bank_account_attributes[0].expiration_month.$model"  v-on:change="changeExpirationMonth($event.target.value)"
                            :class="{[ view_class_view.classInputs.no_valid ]: savingDataModelValidations.bank_account_attributes[0].expiration_month.$error,
                              [ view_class_view.classInputs.valid ]:!savingDataModelValidations.bank_account_attributes[0].expiration_month.$invalid }">
                              <option value="" selected="true" disabled="disabled">MM</option>
                              <option :value="month" v-for="(month, i) in list_months" :key="i" :id="'option_month_'+i">{{month}}</option>
                          </select>
                        </div>
                          <div style="width: 100%;">
                            <select  class="rounded-lg w-full px-3 py-3 clear-focus border-2" style="border-left:none;border-top-left-radius:0;border-bottom-left-radius:0 " 
                            id="input_expiration_date_saving_data_year" v-model.trim="savingDataModelValidations.bank_account_attributes[0].expiration_year.$model" v-on:change="changeExpirationYear($event.target.value); getMonths($event.target.value);"
                            :class="{[ view_class_view.classInputs.no_valid ]: savingDataModelValidations.bank_account_attributes[0].expiration_year.$error,
                              [ view_class_view.classInputs.valid ]:!savingDataModelValidations.bank_account_attributes[0].expiration_year.$invalid }">
                              <option value="" selected="true" disabled="disabled">AA</option>
                              <option :value="year" v-for="(year, i) in list_years" :key="i" :id="'option_year_'+i">{{year}}</option>
                            </select>
                          </div>
                      </div>
                    </div>
                    

                <div class="content-text" style="float:left;margin-top:10px">
                      <div v-if="savingDataModelValidations.bank_account_attributes[0].expiration_month.$dirty">
                        <div class="input-errors" v-for="error of savingDataModelValidations.bank_account_attributes[0].expiration_month.$errors" :key="error.$uid">
                          <span :class="view_class_view.div_container_error.text_error" class="errors">{{ error.$message }}</span>
                      </div>
                    </div>
                </div>

                <div class="content-text" style="float:left;margin-top:10px">
                      <div v-if="savingDataModelValidations.bank_account_attributes[0].expiration_year.$dirty">
                        <div class="input-errors" v-for="error of savingDataModelValidations.bank_account_attributes[0].expiration_year.$errors" :key="error.$uid">
                          <span :class="view_class_view.div_container_error.text_error" class="errors">{{ error.$message }}</span>
                      </div>
                    </div>
                </div>
              </div>

              <div>
                <ChooseButton 
                    :buttons="savingperiod"
                    v-on:choose-button="selectsavingPeriod($event)"
                    label="Periodo de ahorro:" 
                    :buttons_styles="buttons_styles"
                    />

                  <div class="content-text" style="float:left;margin-top:10px">
                    <div v-if="savingDataModelValidations.saving_registration_attributes.payment_frecuency.$dirty">
                      <div class="input-errors" v-for="error of savingDataModelValidations.saving_registration_attributes.payment_frecuency.$errors" :key="error.$uid">
                        <span :class="view_class_view.div_container_error.text_error" class="errors">{{ error.$message }}</span>
                    </div>
                  </div>
               </div>

            </div>

            <div>
                <p id="label_savings_amount" class="label-input" >Importe de ahorro: </p>
                <input type="text" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor mt-2" id="input_amount_saving_data"   v-model.trim="savingDataModelValidations.saving_registration_attributes.amount.$model" style="color:#3B3B3B;" v-money="money" inputmode="numeric"
                :class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: savingDataModelValidations.saving_registration_attributes.amount.$error,
                  [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!savingDataModelValidations.saving_registration_attributes.amount.$invalid,
                  [view_class_view.classInputs.default ]: savingDataModelValidations.saving_registration_attributes.amount.$invalid && !savingDataModelValidations.saving_registration_attributes.amount.$error  }" @blur="importFlag=true">

                
               <div class="content-text" style="float:left;margin-top:10px">
                    <div v-if="savingDataModelValidations.saving_registration_attributes.amount.$dirty && importFlag">
                      <div class="input-errors" v-for="error of savingDataModelValidations.saving_registration_attributes.amount.$errors" :key="error.$uid">
                        <span :class="view_class_view.div_container_error.text_error" class="errors">{{ error.$message }}</span>
                    </div>
                  </div>
               </div>
            </div> 

   
          </div>
      </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted, onBeforeMount, watch } from 'vue';
import useVuelidate from "@vuelidate/core";
import { VMoney } from "v-money";
import ChooseButton from "./Forms/ChooseButton.vue";

export default {
name: "SavingDataComponent",
directives: { money: VMoney },
props: {
  buttons_styles:{},
  validations:{},
  view_class_view:{},
  active_payment_methods: {
    type: Object,
    default() {
      return {
        "button_payroll_saving_data": true,
        "button_card_charge_saving_data": true
      };
    }
  }
},
setup(props, {emit}){

  onBeforeMount(()=> {
    showPaymentMethods();
  });

  function showPaymentMethods(){
    if(props.active_payment_methods["button_payroll_saving_data"]){
      savingData.value.push({ id: "button_payroll_saving_data", value: "ViaNomina", text: "Vía Nómina" });
    }

    if(props.active_payment_methods["button_card_charge_saving_data"]){
      savingData.value.push({ id: "button_card_charge_saving_data", value: "CargoTarjeta", text: "Cargo Tarjeta"});
    }

  }

  const list_banks = ref([]);
  const accountType = ref({});
  const savingData = ref([]);

  const savingperiod= [
    { id: "button_fortnightly_saving_data", value: "Quincenal", text: "Quincenal"},
    { id: "button_montly_saving_data", value: "Mensual", text: "Mensual" },
  ];

  const typesavingPeriod = ref("N/A");
  const list_years = ref([]);
  const list_months = ref([]);
  const money = {
    decimal: ".",
    thousands: ",",
    prefix: "",
    suffix: "",
    precision: 0,
    masked: false
  };

  const saving_registration_attributes = ref({
    amount: "",
    status: "",
    date_of_end: "",
    date_of_start: "",
    payment_method: "",
    payment_frecuency: "",
    number_of_contribution:""
  });

  const bank_account_attributes = ref({
      0: {
        bank_name: "",
        account_type: "",
        account_number: "",
        expiration_year: "",
        expiration_month: ""
      }
  });

  const importFlag = ref(false)
  
  let savingModelValidations = ref({
    saving_registration_attributes:{
      amount: "",
      payment_method: "",
      payment_frecuency: "",
    },
    bank_account_attributes:{
      0:{
        bank_name: "",
        account_type: "",
        account_number: "",
        expiration_year: "",
        expiration_month: ""
      }
    }
  });

  let savingDataModelValidations = useVuelidate(props.validations, savingModelValidations);

  onMounted(() => {
    getYearsCard();
    getMonths(parseInt((new Date().getMonth()+1).toString().substring(2, 4)));
    getBanks();
  });

  watch( savingModelValidations.value.saving_registration_attributes , (value) => {
    emit("saving_registration_attributes",value)
  });

  watch( savingModelValidations.value.bank_account_attributes , (value) => {
    emit("bank_account_attributes",value)
  });

  function statusEmployment(valueRefs){
    // console.log("Status employment", valueRefs);
    savingData.value = [];
    if(valueRefs.laboral_status == "ACTIVO" && valueRefs.principal_occupation == "Empleado" && valueRefs.workCenter == "GRUPO CABSA"  ||  valueRefs.principal_occupation == "Trabajador de la educacion" ){
      savingData.value = [
        { id: "button_payroll_saving_data", value: "ViaNomina", text: "Vía Nómina" },
        { id: "button_card_charge_saving_data", value: "CargoTarjeta", text: "Cargo Tarjeta"},
      ];
    }

    if(valueRefs.laboral_status == "ACTIVO" && (valueRefs.principal_occupation == "Negocio Propio" || valueRefs.workCenter == "OTRO") ){
      savingData.value = [
        {id: "button_card_charge_saving_data", value: "CargoTarjeta", text: "Cargo Tarjeta"},
      ]
    }

    if(valueRefs.laboral_status=="JUBILADO" || valueRefs.laboral_status=="ESTUDIANTE"){
      savingData.value = [
        {id: "button_card_charge_saving_data", value: "CargoTarjeta", text: "Cargo Tarjeta"},
      ]
    }
  }

  function changeAccountNumber(value){
    savingModelValidations.value.bank_account_attributes[0].account_number = value;
  }

  function changeExpirationMonth(value){
    savingModelValidations.value.bank_account_attributes[0].expiration_month = value;
  }

  function changeExpirationYear(value){
    savingModelValidations.value.bank_account_attributes[0].expiration_year = value;
  }

  function changePaymentMethod(value){
    savingModelValidations.value.saving_registration_attributes.payment_method = value;
    savingModelValidations.value.bank_account_attributes[0].account_type = "";
    clearControls();
  }

  function changeAccountType(value){
    savingModelValidations.value.bank_account_attributes[0].account_type = value;
    clearControls();
  }

  function changeBankName(value){
    savingModelValidations.value.bank_account_attributes[0].bank_name = value;
  }

  function clearControls(){
    savingModelValidations.value.bank_account_attributes[0].account_number = "";
    savingModelValidations.value.bank_account_attributes[0].expiration_month = "";
    savingModelValidations.value.bank_account_attributes[0].expiration_year = "";
    savingModelValidations.value.bank_account_attributes[0].bank_name = "";
  }

  function selectsavingPeriod(value){
    savingModelValidations.value.saving_registration_attributes.payment_frecuency = value;
  }

  function execute_validation(){

    importFlag.value = true;
    savingDataModelValidations.value.$validate();
    if(savingDataModelValidations.value.$error){
      return false;
    }
    return savingModelValidations.value;
  }

  function getYearsCard(){
    var years = [];
    var startYear = new Date().getFullYear() - 1;
    var lastYear = new Date().getFullYear() + 5;
      
    while (parseInt(startYear) < parseInt(lastYear) ) {
        startYear++;
        var year = startYear;
        years.push(parseInt(year.toString().substring(2, 4)));
    }
    list_years.value = years;
    return years;
  }

  function getMonths(date){
    list_months.value = [];
    date = parseInt(date);
    let month = new Date().getMonth()+1;
    let months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    if(date === list_years.value[0]){
      months.forEach(element => {
        if(element >= month){
          list_months.value.push(element);
        }
      });
    }else{
      list_months.value = months;
    }
  }

  async function getBanks() {
      list_banks.value = ["ABC CAPITAL","ACCIVAL","ACTINVER","AFIRME","AKALA","AMERICAN EXPRESS","ASEA","AUTOFIN","AZTECA","B&B","BAJIO","BAMSA","BANAMEX","BANCO FAMSA","BANCOMEXT","BANCOPPEL","BANJERCITO","BANOBRAS","BANORTE","BANREGIO","BANSEFI","BANSI","BARCLAYS","BBASE","BBVA BANCOMER","BMONEX","BMULTIVA","BULLTICK CB","CB ACTINVER","CB INTERCAM","CB JPMORGAN","CBDEUTSCHE","CI BOLSA","CIBANCO","CLS","COMPARTAMOS","CONSUBANCO","CREDIT SUISSE","DEUTSCHE","ESTRUCTURADORES","EVERCORE","FINAMEX","FINCOMUN","GBM","HDI SEGUROS","HIPOTECARIA FEDERAL","HSBC","INBURSA","INDEVAL","ING","INTERACCIONES","INTERBANCO","INVEX","IXE","JP MORGAN","KUSPIT","LIBERTAD","MAPFRE","MASARI","MERRILL LYNCH","MIFEL","MONEXCB","N/A","NAFIN","Nombre corto","Nombre corto","OACTIN","OPCIONES EMPRESARIALES DEL NOROESTE","ORDER","PROFUTURO","REFORMA","SANTANDER","SCOTIABANK","SEGMTY","SKANDIA","SKANDIA","SOFIEXPRESS","STERLING","STP","SU CASITA","TELECOMM","THE ROYAL BANK","TIBER","TOKYO","UBS BANK","UNAGRA","UNICA","VALMEX","VALUE","VE POR MAS","VECTOR","VOLKSWAGEN","WAL-MART","ZURICH","ZURICHVI"];
  }

  function fomartNumber(value){
    var regex = /^[,.]+$/;
    if (regex.test(value) != true) {
      value = value.replace(
        /[^0-9.]+/g,
        ""
      );
    }
    return value;
  }

  return {
      savingModelValidations,
      savingDataModelValidations,
      list_banks,
      accountType,
      savingData,
      savingperiod,
      typesavingPeriod,
      list_years,
      list_months,
      money,
      saving_registration_attributes,
      bank_account_attributes,
      importFlag,
      statusEmployment,
      changePaymentMethod,
      changeAccountType,
      clearControls,
      selectsavingPeriod,
      execute_validation,
      getYearsCard,
      getMonths,
      getBanks,
      fomartNumber,
      changeBankName,
      changeAccountNumber,
      changeExpirationMonth,
      changeExpirationYear
  };
},
components:{
  ChooseButton
}
}
</script>